import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Loading from "../../components/Genericos/Loading/Loading";
import Modal from "../../components/Genericos/Modal/Modal";
// import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import Toaster from "../../../global/component/Genericos/Toaster/Toaster";
import BuscadorConsultaMedica from "../../components/Turnos/BuscadorConsultaMedica/BuscadorConsultaMedica";
// import MultitabHome from "../../components/Turnos/MultitabHome/MultitabHome";
// import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import {
  LimpiarSelectCM,
  LimpiarSelectGlobal,
  SelectUserCM,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { estudioGrupo } from "../../context/Actions/estudioGrupo/estudioGrupo";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { showModal, hideModal } from "../../context/Actions/modal/modal";
import { logoutConsultaMedTurnos } from "../../context/Actions/turnos/consultaMedTurnos";
import { logoutEstudiosTurnos } from "../../context/Actions/turnos/estudioTurnos";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { PortalContext } from "../../context/Provider";
// import { multiTabsData } from "../../../global/utils/multiTabData";
import "./ConsultaMedica.css";
import { Device } from "@capacitor/device";
import { GlobalContext } from "../../../global/context/Provider";
import { getPlatforms } from "@ionic/react";
import {
  dispositivoPacienteDeleteReset,
  dispositivoPacienteFlgVinculadoSetTrue,
  dispositivoPacientePostReset,
  wsDeleteDispositivoPaciente,
  wsGetDispositivoPaciente,
  wsPostDispositivoPaciente,
} from "../../context/Actions/dispositivoPaciente/dispositivoPaciente";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import routes from "_+_Portal/routes/listRoutes";
import { motion } from "framer-motion";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
// import BuscadorTurnos from "../BuscadorTurnos/BuscadorTurnos";

const ConsultaMedica = () => {
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    estudioTurnosState,
    consultaMedTurnosState,
    modalState,
    laboGrupoState,
    laboGrupoDispatch,
    modalDispatch,
    selectDropDownDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    estudioTurnosDispatch,
    consultaMedTurnosDispatch,
    dispositivoPacienteState,
    dispositivoPacienteDispatch,
    textosState,
    // presentismoState,
    tokenFCMState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [dtoTokenFCM, setDtoTokenFCM] = useState({
    id: tokenFCMState.tokenFCM.newToken,
    descripcion: null,
  });
  // const [tabsData, setTabsData] = useState(multiTabsData);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  //repetir en las paginas para tener los datos de los grupos
  useEffect(() => {
    if (configState.config.data !== null) {
      if (estudioGrupoState.estudioGrupo.data === null) {
        estudioGrupo()(estudioGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.data === null &&
        configState.config.data.opcLaboratorio
      ) {
        laboGrupo()(laboGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.centros === null &&
        configState.config.data.opcLaboratorio
      ) {
        wsGetLaboCentros()(laboGrupoDispatch);
      }
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "CONSULTA_MEDICA"
      ) {
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
      }
    }
    //eslint-disable-next-line
  }, [configState.config.data]);

  const onChangeMultitabMobile = (e) => {
    // Aquí hay que hacer un dispatch
    // Para poder elegir el usuario
    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth.data.paciente.codigo &&
        e.manejoTurnos
      ) {
        SelectUserCM({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch
        );
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch
        );
      } else if (e.id !== authState.auth.data.paciente.codigo) {
        // Toaster que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro"
        )(modalDispatch);

        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      }
    } else {
      LimpiarSelectCM()(selectDropDownDispatch);
      // comentado como en estudios.
      // LimpiarSelectGlobal()(selectDropDownDispatch);
    }
  };

  // useEffect(() => {
  //   if (configState.config.data !== null) {
  //     let tabsAux = tabsData;
  //     if (configState.config.data.opcLaboratorio === false) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 2);
  //     }
  //     if (configState.config.data.opcRecetaDigital === false) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 3);
  //     }
  //     if (
  //       configState.config.data.opcRecetaDigital === false &&
  //       configState.config.data.opcLaboratorio === false &&
  //       configState.config.data.opcBuscadorTurnos === false
  //     ) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 3 && i.id !== 2);
  //     }
  //     if (configState.config.data.opcBuscadorTurnos) {
  //       tabsAux = tabsAux.filter((i) => i.id !== 0 && i.id !== 1 && i.id !== 2);
  //     } else {
  //       tabsAux = tabsAux.filter((i) => i.id !== 5);
  //     }
  //     setTabsData(tabsAux);
  //   }
  // }, [configState.config.data]);

  useEffect(() => {
    // ----------------------- LOGUEO MOBILE ---------------------------------------
    if (
      (getPlatforms()[0] === "android" ||
        getPlatforms()[0] === "ios" ||
        getPlatforms()[0] === "iphone") &&
      dtoTokenFCM.id
    ) {
      const idApp = dtoTokenFCM.id;
      const idPaciente = JSON.stringify(authState.auth.data.paciente.codigo);

      if (idApp) {
        if (idPaciente) {
          localStorage.setItem("idApp", idApp);
          localStorage.setItem("idPaciente", idPaciente);
        }
      }
    }
    // ----------------------- LOGUEO MOBILE ---------------------------------------
  }, [dtoTokenFCM.id, authState.auth.data.paciente.codigo]);

  // ------------------------ MODAL PUBLICITARIO ------------------------------------

  useEffect(() => {
    let publicidad = textosState?.textos?.data?.publicidades;
    const view = JSON.parse(localStorage.getItem("publicidad_portal"));
    if (publicidad && publicidad.length > 0 && !view) {
      showModal(
        "Turnos/Publicidad/Publicidad",
        {
          publicidad: publicidad,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  }, [
    textosState?.textos?.data?.publicidades,
    estudioGrupoState.estudioGrupo.loading,
  ]);

  // ------------------------ MODAL PUBLICITARIO ------------------------------------

  const dismiss = () => {
    hideModal()(modalDispatch);
    dispositivoPacienteFlgVinculadoSetTrue()(dispositivoPacienteDispatch);
  };

  const [flgDispositivoPaciente, setFlgDispositivoPaciente] = useState(false);

  useEffect(() => {
    if (authState.auth.data !== null && authState.auth.data !== undefined) {
      //si tengo token FCM que viene de la app, hago el getDispositivoPaciente y valido para que lo haga una sola vez
      if (
        dtoTokenFCM.id !== undefined &&
        dtoTokenFCM.id !== null &&
        !flgDispositivoPaciente &&
        dispositivoPacienteState.dispositivoPaciente.data === null
      ) {
        wsGetDispositivoPaciente()(dispositivoPacienteDispatch); // traigo datos desde el ws
        obtenerNombreDispositivo();
        setFlgDispositivoPaciente(true);
      }
    }
  }, [authState.auth.data, dtoTokenFCM]);

  useEffect(() => {
    //escucho
    if (
      dispositivoPacienteState.dispositivoPaciente.data !== null &&
      dispositivoPacienteState.dispositivoPaciente.data !== ""
    ) {
      if (
        dtoTokenFCM.id !==
          dispositivoPacienteState.dispositivoPaciente.data.idapp &&
        !dispositivoPacienteState.dispositivoPaciente.flgVinculado &&
        dtoTokenFCM.id !== null &&
        dtoTokenFCM.descripcion !== null
      ) {
        showModal(
          "Genericos/FCMTokenModal/FCMTokenModal",
          { dismiss: dismiss, desvincular: desvincularDispositivoPaciente },
          [],
          "centro",
          true
        )(modalDispatch);
      }
    } else {
      if (
        dtoTokenFCM.id !== undefined &&
        dtoTokenFCM.id !== null &&
        dtoTokenFCM.descripcion !== null &&
        dtoTokenFCM.descripcion !== undefined
      ) {
        //ingreso por primera vez si no tengo token vinculado
        wsPostDispositivoPaciente(dtoTokenFCM)(dispositivoPacienteDispatch);
      }
    }
  }, [dispositivoPacienteState.dispositivoPaciente.data]);

  const desvincularDispositivoPaciente = () => {
    wsDeleteDispositivoPaciente()(dispositivoPacienteDispatch);
  };

  const [flgDesvincular, setFlgDesvincular] = useState(false);

  useEffect(() => {
    //si se desvinculo correctamente el dispositivo, vinculo con el dispositivo actual
    if (
      dispositivoPacienteState.dispositivoPaciente.delete &&
      dispositivoPacienteState.dispositivoPaciente.delete !== null
    ) {
      wsPostDispositivoPaciente(dtoTokenFCM)(dispositivoPacienteDispatch);
      setFlgDesvincular(true);
      dispositivoPacienteDeleteReset()(dispositivoPacienteDispatch);
      dismiss();
    }
  }, [dispositivoPacienteState.dispositivoPaciente.delete]);

  useEffect(() => {
    //Si el post de vinculacion se realiza correctamente, doy un mensaje en pantalla con un toaster success
    if (dispositivoPacienteState.dispositivoPaciente.post && flgDesvincular) {
      showToaster(
        {
          texto: "Se desvinculo correctamente el dispositivo.",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      dispositivoPacientePostReset()(dispositivoPacienteDispatch);
      setFlgDesvincular(false);
    }
  }, [dispositivoPacienteState.dispositivoPaciente.post]);

  const obtenerNombreDispositivo = () => {
    //obtiene el modelo del dispositivo y lo seteo en el dto
    Device.getInfo().then((info) => {
      setDtoTokenFCM({ ...dtoTokenFCM, descripcion: info.model });
    });
  };

  return (
    <>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}

      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />

      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <Loading
        dataLoading={
          estudioGrupoState.estudioGrupo.loading ||
          estudioTurnosState.estudioTurnos.loading ||
          consultaMedTurnosState.consultaMedTurnos.loading ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading &&
            "Cargando consultas médicas...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando consultas médicas...") ||
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading) &&
            "Cargando...")
        }
      />
      {/* <MultitabMobile
        posicionMultitab={1}
        onChangeMultitabMobile={onChangeMultitabMobile}
        type={"CONSULTA_MEDICA"}
      /> */}

      {estudioGrupoState.estudioGrupo.data &&
        !estudioGrupoState.estudioGrupo.loading && (
          <motion.div
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
            className="ptur-bodyContainer-ConsultaMedica"
          >
            {/* <Sidebar /> */}
            <div className="ptur-consultaMedica-container">
              <TituloSaludo />
              <div className="ptur-consultaMedica-buscador">
                <div className="ptur-consultaMedica-tabs">
                  {/* <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} /> */}
                </div>
                <BuscadorConsultaMedica
                  onChangeMultitabMobile={onChangeMultitabMobile}
                />
              </div>
            </div>
          </motion.div>
        )}
    </>
  );
};

export default ConsultaMedica;
